import {invert} from 'lodash';
import {ISSUE_ATTRIBUTE_NAMES} from './issue-attribute-names';

export const baseRequiredFields = {
  [ISSUE_ATTRIBUTE_NAMES.ISSUE_SUB_TYPE_ID]: {isRequired: true},
  [ISSUE_ATTRIBUTE_NAMES.STATUS]: {isRequired: true},
  [ISSUE_ATTRIBUTE_NAMES.TITLE]: {isRequired: true}
};

export const requiredFieldsServerToClientMapping = {
  locationDescription: ISSUE_ATTRIBUTE_NAMES.LOCATION_DETAILS,
  lbsLocation: ISSUE_ATTRIBUTE_NAMES.LOCATION_ID,
  rootCause: ISSUE_ATTRIBUTE_NAMES.ROOT_CAUSE_ID,
  owner: ISSUE_ATTRIBUTE_NAMES.OWNER_ID,
  linkedDocument: ISSUE_ATTRIBUTE_NAMES.LINKED_DOCUMENTS
};

export const requiredFieldsClientToServerMapping = invert(requiredFieldsServerToClientMapping);
